import React from 'react';

import values  from '../../../../values';
import Context from '../../../../context';

import { Components     } from './components';
import { useTranslation } from 'react-i18next';
import {
  Pagination,
  BreadCrumb,
  TableHeader,
  TableLoading,
  CustomButton2,
  ResponsiveView,
} from '../../../../components';

import './index.scss';

type Props = {
  rqData: any;
  showModalData: any;
};

const PayTodriverScreen: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { requestDebt, setRequestRequestDebt, setShowModal } = React.useContext(Context.payAdminToDriverContext);

  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="transactions-screen">
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </ResponsiveView.Column>
        <ResponsiveView.Column extraLarge={4} large={5} medium={7} className="search-and-filter-wrapper">
          {" "}
          {/* <Components.Filter />
          <Components.Search /> */}
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <ResponsiveView.Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.PAY_ADMIN_TO_DRIVER.map((item) => t(item))}/>
            {props.rqData?.status === "loading" ? (<TableLoading />) : (<Components.Body data={props.rqData} />)}
          </table>
        </div>
        <div style={{display: "flex", justifyContent: "center", marginTop: "2rem", gap: "1rem"}}>
          <div></div>
          <CustomButton2 title={"خروجی اکسل"} type="secondary" onClick={() => setShowModal("EXPORT_EXCEL")}/>
          <CustomButton2 title={"تغییر وضعیت"} onClick={() => setShowModal("CHANGE_STATUS")}/>
        </div>
      </ResponsiveView.Container>
      {props.rqData?.status === "success" &&
        props.rqData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={requestDebt?.page}
              totalPages={props.rqData?.data?.result?.totalPages}
              onPaginate={(page: number) => setRequestRequestDebt({...requestDebt, page: page})}
            />
          </div>
        )}
      <Components.ChangeStatus />
      <Components.ExportExcel />
      <Components.Accept />
      <Components.Reject />
      <Components.SendToBank />
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default PayTodriverScreen;
